<template>
  <div class="unusual" style="display: inline-block">
    <yxt-tooltip :content="content" placement="top">
      <div style="display: inline-block; color: #f5222d; cursor: pointer">
        <yxt-svg
          class="d-icon ml12 unusual-middle"
          color="#F5222D"
          width="20px"
          height="20px"
          icon-class="info-cirlce-o"
        />
      </div>
    </yxt-tooltip>
  </div>
</template>

<script>
import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
export default {
  name: 'Unusual',
  props: {
    content: {
      type: String,
      default: () => {
        return i18n.t('pc_spmodel_pl_data_err');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.unusual .unusual-middle {
  vertical-align: middle;
}
</style>
